export default __webpack_public_path__ + "static/media/hightlight_acess_4.458af269.svg";